import api from '@/api'

export default {
  namespaced: true,
  state: {
    items: [],
    fetching: false
  },
  actions: {
    async fetchFlavors ({ state, commit, getters }) {
      commit('fetching')

      const flavors = await api.netshoes.getFlavors()

      commit('setFetchData', flavors)
    }
  },
  getters: {
    getFlavors: state => () => state.items
  },
  mutations: {
    setFetchData (state, items) {
      state.items = items
      state.fetching = false
    },
    fetching (state) {
      state.fetching = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/flavors.js